import React from "react"
import types from "prop-types"
import { SURVEY_SUBMISSION_CREATED_PATH, surveySubmissionsUploadsPath } from "utils/routeHelpers"
import { THANKS_PARAM } from "utils/queryParameter"
import { SecondaryButton } from "shared/buttons"
import { FileUploadContextProvider } from "contexts/FileUploadContext"
import FileUploader, { MAX_FILE_COUNT } from "./Content/FileUploader"
import FilePreviewList from "./Content/FilePreviewList"
import AuthenticatedDetails from "../Forms/FormElements/AuthenticatedDetails"

export const FormSubmissionUploadsPage = ({
  formSubmissionSlug, uploadsCount, publicIdentifier, uploadsTracked, uploadsAuthenticated,
}) => {
  if (uploadsCount > MAX_FILE_COUNT) return null

  const goToFormSubmissionPage = () => {
    const url = window.location.pathname

    if (url === surveySubmissionsUploadsPath()) {
      window.location.replace(SURVEY_SUBMISSION_CREATED_PATH)
    } else {
      window.location.replace(`${url.substring(0, url.lastIndexOf("/"))}?${THANKS_PARAM}=t`)
    }
  }

  return (
    <div className="mx-auto mt-6 md:mb-12">
      <div className="bg-white pb-8 rounded-b-xl">
        <div className="flex flex-col items-center gap-6">
          {
            uploadsAuthenticated && (
              <AuthenticatedDetails
                className="w-3/4 mt-2 p-4 form-details-box"
                tracksSubmissions={uploadsTracked}
              />
            )
          }
          <FileUploadContextProvider
            formSubmissionSlug={formSubmissionSlug}
            publicIdentifier={publicIdentifier}
          >
            <FilePreviewList />

            <FileUploader />
          </FileUploadContextProvider>
        </div>
      </div>
      <div className="flex flex-col items-center my-6">
        <SecondaryButton
          text="Done With Uploads"
          onClick={goToFormSubmissionPage}
        />
      </div>
    </div>
  )
}

FormSubmissionUploadsPage.propTypes = {
  formSubmissionSlug: types.string.isRequired,
  uploadsCount: types.number.isRequired,
  publicIdentifier: types.string.isRequired,
  uploadsTracked: types.bool.isRequired,
  uploadsAuthenticated: types.bool.isRequired,
}

export default FormSubmissionUploadsPage
